import getQuery from '../queries/user-generated-content/getReviewPhotosQuery';
import { useQuery } from './useQuery';

const Query = getQuery();

const useReviewsPhotos = ({ itemId, options, ssr = true }) => {
  let opts = options;
  if (typeof opts === 'undefined') {
    opts = {
      ssr,
      variables: {
        itemId
      }
    };
  }
  return useQuery(Query, opts);
};

export default useReviewsPhotos;
